import { Box, Card, Typography, alpha } from '@mui/material';
import MenusList from './menu-list';

const QuickAccess: React.FC = () => {
    return (
        <Card
            elevation={0}
            sx={(theme) => ({
                background: `linear-gradient(160deg, ${alpha(
                    theme.palette.primary.main,
                    theme.palette.mode === 'dark' ? 0.035 : 0.02,
                )} 0%, transparent 40%), ${theme.palette.background.paper}`,
                height: '100%',
                borderRadius: '18px',
                border: 0,
                overflow: 'hidden',
                boxShadow:
                    theme.palette.mode === 'light'
                        ? '0 12px 36px rgba(17, 24, 39, 0.045)'
                        : `0 10px 30px ${alpha(theme.palette.common.black, 0.12)}`,
            })}>
            <Box
                sx={{
                    px: { xs: 1.75, md: 2 },
                    pt: 1.75,
                    pb: 1.15,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1.25,
                }}>
                <Box sx={{ minWidth: 0 }}>
                    <Typography
                        className="font-yekan-heavy"
                        sx={{ fontSize: 14.5, color: 'text.primary' }}>
                        دسترسی سریع
                    </Typography>
                    <Typography
                        sx={{
                            mt: 0.2,
                            fontSize: 10.5,
                            color: 'text.secondary',
                            lineHeight: 1.65,
                        }}>
                        تنظیمات مهم درگاه، بدون رفت‌وآمد بین صفحه‌ها
                    </Typography>
                </Box>
                <Box
                    sx={(theme) => ({
                        width: 38,
                        height: 38,
                        borderRadius: '12px',
                        bgcolor: alpha(
                            theme.palette.mode === 'dark'
                                ? theme.palette.primary.light
                                : theme.palette.primary.main,
                            theme.palette.mode === 'dark' ? 0.13 : 0.08,
                        ),
                        color:
                            theme.palette.mode === 'dark'
                                ? theme.palette.primary.light
                                : theme.palette.primary.main,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        '& i': { fontSize: 15 },
                    })}>
                    <i className="fa-light fa-grid-2" />
                </Box>
            </Box>

            <MenusList />
        </Card>
    );
};

export default QuickAccess;
